import { ReactNode } from "react";
import "./knowledge-base-article-page.scss";
import {
  BaseLayout,
  SiteHeaderComponent,
} from "design-system/components/layouts/base";
import {
  BreadcrumbsProps,
  Breadcrumbs,
} from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import {
  ArticleTopper,
  ArticleTopperProps,
} from "design-system/components/toppers/article-topper/article-topper";
import { SiteFooterProps } from "design-system/components/universal/site-footer/site-footer";
import { PageSection } from "design-system/components/layouts/page-section/page-section";
import {
  TeaseRow,
  TeaseRowProps,
} from "design-system/components/blocks/tease-row/tease-row";
import { Cta, CtaProps } from "design-system/components/blocks/cta/cta";
import { ArticleTeaseProps } from "design-system/components/primitives/article-tease/article-tease";

export interface KnowledgeBaseArticlePageProps {
  header: SiteHeaderComponent;
  footer?: SiteFooterProps;
  topper?: ArticleTopperProps;
  breadcrumbs: BreadcrumbsProps;
  children: ReactNode;
  teases?: Array<ArticleTeaseProps>;
  teasesHeader?: TeaseRowProps["headerContent"];
  cta?: CtaProps;
}

export function KnowledgeBaseArticlePage({
  header,
  footer,
  topper,
  breadcrumbs,
  children,
  teases,
  teasesHeader,
  cta,
}: KnowledgeBaseArticlePageProps) {
  return (
    <BaseLayout
      className="hbs-knowledge-base-article-page"
      header={header}
      footer={footer}
      theme="white"
    >
      <main id="skipto-main" tabIndex={-1}>
        <ArticleTopper {...topper} isKnowledgeBase />

        {breadcrumbs && <Breadcrumbs {...breadcrumbs} theme="white" />}

        <div className="hbs-knowledge-base-article-page__wrapper">
          <div className="hbs-knowledge-base-article-page__body">
            <div className="hbs-knowledge-base-article-page__main">
              <section className="hbs-page-body hbs-knowledge-base-article-page__content">
                {children}
                {teases?.length || cta ? (
                  <PageSection theme="light">
                    {teases?.length && teases.length > 0 ? (
                      <TeaseRow
                        teases={teases.map((props) => ({
                          name: "ArticleTease",
                          props: {
                            ...props,
                            type: "Article",
                            theme: "white",
                            isSmall: true,
                          },
                        }))}
                        align="full"
                        teaseStyle="content"
                        wrap="wrap"
                        headerContent={teasesHeader}
                      />
                    ) : null}
                    {cta && <Cta {...cta} />}
                  </PageSection>
                ) : null}
              </section>
            </div>
          </div>
        </div>
      </main>
    </BaseLayout>
  );
}
